import { approvedOrDeclined } from "../../../../../../../utils";

export const useJobEmployeeAccept = () => {
    const token = sessionStorage.getItem("token")


    const handleAcceptOrDecline = async (job, status) => {
        try {
            await approvedOrDeclined(token, job, status)
        } catch (error) {
            console.log("Error", error);
        }
    }


    return {
        handleAcceptOrDecline
    }
}